import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import DetalheProjetoPage from './pages/ProjetoDetalhePage';
import MinhasTarefasPage from './pages/MinhasTarefasPage';
import TarefasGlobalPage from './pages/TarefasGlobalPage';
import MeuDiaPage from './pages/MeuDiaPage';
import PlanejamentoSemanaPage from './pages/PlanejamentoSemanalPage';
import ProtectedRoute from './components/ProtectedRoute';
import FeatureRoute from './components/FeatureRoute';
import AppLayout from './layout/AppLayout';
import { useAuth } from './hooks/useAuth';
import ProjetosPage from './pages/ProjetosPage';
import PerfilPage from './pages/PerfilPage';
import DashboardGestorPage from './pages/DashboardGestorPage';
import DailyGestorPage from './pages/DailyGestorPage';
import HabitosPage from './pages/HabitosPage';
import WorkspacesPage from './pages/WorkspacesPage';
import LevelUpHubPage from './pages/LevelUpHubPage';
import MetasPage from './pages/MetasPage';
import SkillsPage from './pages/SkillsPage';
import TeamPDIPage from './pages/TeamPDIPage';
import PlanejamentoDiaPDIPage from './pages/PlanejamentoDiaPDIPage';
import PlanejamentoSemanalPDIPage from './pages/PlanejamentoSemanalPDIPage';
import NotesPage from './pages/NotesPage';
import OnePagePage from './pages/OnePagePage';
import CapturarPage from './pages/CapturarPage';
import LembretesPage from './pages/LembretesPage';
import TarefasCentralPage from './pages/TarefasCentralPage';
import ModelosTarefaPage from './pages/ModelosTarefaPage';
import PlanosPage from './pages/PlanosPage';
import DiarioDesenvolvimentoPage from './pages/DiarioDesenvolvimentoPage';
import OkrPage from './pages/OkrPage';

function App() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  return (
    <Routes>

      {/* Login fora do layout */}
      <Route
        path="/login"
        element={
          isAuthenticated ? <Navigate to="/dashboard" /> : <LoginPage />
        }
      />

      {/* Captura fica fora do layout: sem sidebar e sem header, o teclado
          abre direto no campo e da para despejar varios itens seguidos. */}
      <Route
        path="/capturar"
        element={
          isAuthenticated ? <CapturarPage /> : <Navigate to="/login" />
        }
      />

      {/* Rotas protegidas com layout */}
      <Route element={<AppLayout />}>

        <Route
          path="/dashboard"
          element={
            isAuthenticated ? <DashboardPage /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/dashboard-gestor"
          element={
            isAuthenticated ? <FeatureRoute feature="dashboard_gestor"><DashboardGestorPage /></FeatureRoute> : <Navigate to="/login" />
          }
        />
        <Route
          path="/daily-gestor"
          element={
            isAuthenticated ? <FeatureRoute feature="daily_gestor"><DailyGestorPage /></FeatureRoute> : <Navigate to="/login" />
          }
        />

        {/* Central de tarefas. A TarefasPage antiga continua no repositorio
            para a limpeza, mas nao esta mais roteada. */}
        <Route
          path="/tarefas"
          element={
            isAuthenticated ? <TarefasCentralPage /> : <Navigate to="/login" />
          }
        />

        <Route
          path="/minhas-tarefas"
          element={
            isAuthenticated ? <MinhasTarefasPage /> : <Navigate to="/login" />
          }
        />

        <Route
          path="/tarefas-global"
          element={
            isAuthenticated ? <TarefasGlobalPage /> : <Navigate to="/login" />
          }
        />

        <Route
          path="/projetos/:id"
          element={
            isAuthenticated ? <DetalheProjetoPage /> : <Navigate to="/login" />
          }
        />

        <Route path="/meu-dia"element={<ProtectedRoute><MeuDiaPage /></ProtectedRoute>}/>
        <Route path="/planejamento-semana" element={isAuthenticated ? (<FeatureRoute feature="planejamento_semanal"><PlanejamentoSemanaPage /></FeatureRoute>) : (<Navigate to="/login" />)}/>
        <Route path="/projetos" element={isAuthenticated ? (<ProjetosPage />) : (<Navigate to="/login" />)}/>
        <Route path="/perfil" element={isAuthenticated ? (<PerfilPage />) : (<Navigate to="/login" />)}/>
        <Route path="/planos" element={isAuthenticated ? (<PlanosPage />) : (<Navigate to="/login" />)}/>
        <Route path="/perfil/workspaces" element={isAuthenticated ? (<WorkspacesPage />) : (<Navigate to="/login" />)}/>
        <Route path="/habitos" element={isAuthenticated ? (<FeatureRoute feature="habitos"><HabitosPage /></FeatureRoute>) : (<Navigate to="/login" />)}/>
        <Route path="/levelup" element={isAuthenticated ? (<FeatureRoute feature="levelup_hub"><LevelUpHubPage /></FeatureRoute>) : (<Navigate to="/login" />)}/>
        <Route path="/metas" element={isAuthenticated ? (<FeatureRoute feature="metas"><MetasPage /></FeatureRoute>) : (<Navigate to="/login" />)}/>
        <Route path="/skills" element={isAuthenticated ? (<FeatureRoute feature="skills"><SkillsPage /></FeatureRoute>) : (<Navigate to="/login" />)}/>
        <Route path="/team-pdi" element={isAuthenticated ? (<FeatureRoute feature="team_pdi"><TeamPDIPage /></FeatureRoute>) : (<Navigate to="/login" />)}/>
        <Route path="/okrs" element={isAuthenticated ? (<FeatureRoute feature="okrs"><OkrPage /></FeatureRoute>) : (<Navigate to="/login" />)}/>
        <Route path="/levelup/dia" element={isAuthenticated ? (<FeatureRoute feature="levelup_dia"><PlanejamentoDiaPDIPage /></FeatureRoute>) : (<Navigate to="/login" />)}/>
        <Route path="/levelup/semana" element={isAuthenticated ? (<FeatureRoute feature="levelup_semana"><PlanejamentoSemanalPDIPage /></FeatureRoute>) : (<Navigate to="/login" />)}/>
        <Route path="/notes" element={isAuthenticated ? (<NotesPage />) : (<Navigate to="/login" />)}/>
        <Route path="/onepage" element={isAuthenticated ? (<FeatureRoute feature="onepage"><OnePagePage /></FeatureRoute>) : (<Navigate to="/login" />)}/>
        <Route path="/lembretes" element={isAuthenticated ? (<LembretesPage />) : (<Navigate to="/login" />)}/>
        <Route path="/diario-desenvolvimento" element={isAuthenticated ? (<DiarioDesenvolvimentoPage />) : (<Navigate to="/login" />)}/>
        {/* Alcancada pela central de tarefas, nao pelo menu: modelo se mantem
            de vez em quando, mas se usa toda semana. */}
        <Route path="/modelos" element={isAuthenticated ? (<FeatureRoute feature="modelos_tarefa"><ModelosTarefaPage /></FeatureRoute>) : (<Navigate to="/login" />)}/>

      </Route>

      {/* fallback */}
      <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />

    </Routes>
  );
}

export default App;
